module.exports = __webpack_public_path__ + "img/10.79ea92c8.jpg";